//import { API_KEY } from '@env';
import api from '../common/api';
import APIHelper from '../common/ApiHelper';
import APIURLConstants from '../common/ApiURLConstants';
//... This API returns Common mail .

export const getCommonMail = async (receiver, title, message) => {
    try {
        const request = {
            to: receiver,
            subject: title,
            body: message,
        };
        const header = {
            'Content-Type': 'application/json'
        };
        console.log('request', request)
        return await APIHelper.post(APIURLConstants.COMMON_MAIL, request,  header )
        //return await api.post(APIURLConstants.COMMON_MAIL, request, { headers: header })
    }
    catch (err) {
        console.error(err)
        //AppInsight.trackException(err);
    }
};